import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ custom, palette, breakpoints }: Theme) => ({
    formRowContainer: {
      border: `4px solid ${palette.common.white}`,
      padding: 16,
    },
    noPadding: {
      padding: 0,
    },
    formControlLabelRoot: {
      paddingBottom: 10,
      marginRight: 0,
    },
    label: {
      color: custom.grey[15],
      textAlign: 'right',
      textTransform: 'uppercase',
      fontWeight: 'bold',
      fontSize: 12,
      lineHeight: '18px',
    },
    labelConfirmed: {
      color: custom.green[2],
    },
    checkbox: {
      padding: 0,
      marginLeft: 5,
      '&.Mui-checked': {
        color: custom.green[2],
      },
      '&:not(.Mui-checked)': {
        color: custom.grey[15],
        '& .MuiIconButton-label:after': {
          content: '""',
          left: 4,
          top: 4,
          height: 15,
          width: 15,
          position: 'absolute',
          backgroundColor: 'white',
        },
        '& svg': {
          zIndex: 1,
        },
      },
    },
    unconfirmed: {
      backgroundColor: custom.orange[0],
      border: `4px solid ${palette.common.white}`,
    },
    raisedTooltip: {
      '& .tooltip': {
        position: 'absolute',
        top: -44,
        right: -50,
        marginLeft: 0,
        [breakpoints.down('sm')]: {
          top: -49,
          right: -15,
        },
      },
    },
  })
);
